import React, { useState } from 'react'
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Button, TextField } from '@material-ui/core';
import { useAccount } from 'hooks/use-account';

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export const Login: React.FC = () => {
  const classes = useStyles();
  const  { name, setName } = useAccount();

  const [ inputName, setInputName ] = useState<string>('');

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <TextField
          fullWidth
          required
          label="おなまえ"
          type="text"
          helperText="なまえをきめてね"
          defaultValue={name}
          onChange={(event) => setInputName(event.target.value)} 
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          color="secondary"
          className={classes.submit}
          onClick={()=>{
            setName(inputName);
          }}
        >
          ろぐいん
        </Button>
      </div>
    </Container>
  );
};
